import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { CONFIGURATIONS } from "components/TableDetails/DeviceDetails/Configuration/Overview/constants";

const ConfigurationTypeInfo = () => {
    const { t } = useTranslation();

    return (
        <ul>
            {CONFIGURATIONS.map(configType => (
                <li key={configType}>
                    <span
                        css={css({
                            fontWeight: "600"
                        })}
                    >
                        {t([`Table##${configType}`, `General##${configType}`])}
                    </span>

                    {" - "}

                    <span>
                        {t(
                            `Table details##tooltip info##devices##configuration overview##${configType}`
                        )}
                    </span>
                </li>
            ))}
        </ul>
    );
};

export default ConfigurationTypeInfo;
